import { render, staticRenderFns } from "./ParticipantFormNfeCoupon.vue?vue&type=template&id=c98d97ca&scoped=true"
import script from "./ParticipantFormNfeCoupon.vue?vue&type=script&lang=js"
export * from "./ParticipantFormNfeCoupon.vue?vue&type=script&lang=js"
import style0 from "./ParticipantFormNfeCoupon.vue?vue&type=style&index=0&id=c98d97ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98d97ca",
  null
  
)

export default component.exports